<template lang="html">
  <div class="empty-box" v-if="end">
    <div>
      {{text}}
    </div>
  </div>
</template>

<script>
export default {
    name:'empty',
    props:{
      text:{type:String,default:"暂无数据"},
      end:{type:Boolean,default:false}
    },
    data() {
        return {}
    }
}
</script>

<style scoped>
.empty-box{display:flex; height:100%;}
.empty-box>div{margin:auto; font-size:2vw; color:#999;}

@media (max-width: 991px){
.empty-box{display:flex; min-height: calc(100vh - 50vw - 55px);}

}
</style>

